import { render, staticRenderFns } from "./WidgetPageButtonLayout.vue?vue&type=template&id=4cb3362a&scoped=true&"
import script from "./WidgetPageButtonLayout.vue?vue&type=script&lang=js&"
export * from "./WidgetPageButtonLayout.vue?vue&type=script&lang=js&"
import style0 from "./WidgetPageButtonLayout.vue?vue&type=style&index=0&id=4cb3362a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb3362a",
  null
  
)

export default component.exports